import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    email: Yup.string().email().trim().required("Please enter your email"),
    password: Yup.string().trim().required("Please enter your password")
  }),
  mapPropsToValues: props => ({
    email: "",
    password: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
